import { useEffect, useRef } from 'react'

export const useLatest = <T>(value: T): React.RefObject<T> => {
  const ref = useRef(value)

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref
}
